import React, { useState, useEffect } from "react";
import axios from "axios";
import Header from "../Components/header";
import Sidebar from "../Components/sidebar";
import { ModifyUser } from "../Components/modalPopup";

const API_URL = process.env.REACT_APP_API_URL;

const UserManagement = () => {
  const [users, setUsers] = useState([]);
  const [error, setError] = useState(null);
  const [editError, setEditError] = useState(null);
  const [editUserId, setEditUserId] = useState(null);
  const [userData, setUserData] = useState({}); // Inizializza i dati utente
  const [isModifyModalOpen, setIsModifyModalOpen] = useState(false);
  const [isAddUserModalOpen, setIsAddUserModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const ruoli = ["admin", "user"];

  /* Fetch all users */
  useEffect(() => {
    const fetchUsers = async () => {
      axios.defaults.withCredentials = true;
      try {
        const response = await axios.get(`${API_URL}/admin/users`);
        console.log("Response:", response.data);
        setUsers(response.data);
      } catch (error) {
        if (error.response && error.response.status === 401) {
          setError("Non sei autorizzato ad accedere a questa pagina.");
        } else {
          console.error("Error fetching users:", error);
          setError("Si è verificato un errore nel recupero degli utenti.");
        }
      }
    };
    fetchUsers();
  }, []);

  /* Get user data for editing */
  useEffect(() => {
    const fetchData = async () => {
      if (!editUserId) return;

      axios.defaults.withCredentials = true;
      try {
        const response = await axios.get(
          `${API_URL}/admin/getUserData/${editUserId}`
        );

        console.log("Response:", response.data);
        if (response.data) {
          console.log("QUI");
          setUserData({
            id: response.data.id_utente,
            nome: response.data.nome,
            cognome: response.data.cognome,
            email: response.data.email,
            num_tel: response.data.num_tel,
            indirizzo: response.data.indirizzo,
            comune: response.data.comune,
            provincia: response.data.provincia,
            cap: response.data.cap,
            ruolo: response.data.ruolo,
          });

          console.log("User data set:", response.data);
          // Ora che i dati sono stati recuperati correttamente, apri il modale
          handleOpenModifyModal(); // Apri il modale qui
        } else {
          console.error("Nessun utente trovato."); // Aggiungi un messaggio di errore se l'utente non viene trovato
        }
      } catch (error) {
        console.error("Errore nel recupero dei dati utente:", error);
        setError(
          "Si è verificato un errore nel recupero dei dati dell'utente."
        );
      }
    };

    fetchData(); // Chiama fetchData quando editUserId cambia
  }, [editUserId]); // useEffect dipende solo da editUserId

  const handleEditClick = (user) => {
    console.log("User selected for editing:", user); // Logga l'utente selezionato
    setEditUserId(user.id_utente);
  };

  useEffect(() => {
    console.log("Editing user ID:", editUserId); // Logga l'ID utente in modifica
  }, [editUserId]);

  useEffect(() => {
    console.log("User data fetched:", userData); // Logga i dati utente appena recuperati
  }, [userData]);

  /* APRI MODALE MODIFICA UTENTE */
  const handleOpenModifyModal = () => setIsModifyModalOpen(true);

  /* CHIUDI MODALE MODIFICA UTENTE */
  const handleCloseModifyModal = () => {
    setIsModifyModalOpen(false);
    setEditUserId(null); // Reset dell'ID utente
    setEditError(null); // Reset dell'errore
    setUserData({ nome: "", cognome: "", email: "", num_tel: "", ruolo: "" }); // Reset dei dati utente
  };

  const handleOpenAddUserModal = () => setIsAddUserModalOpen(true); //APRI MODALE AGGIUNTA UTENTE
  const handleCloseAddUserModal = () => setIsAddUserModalOpen(false); //CHIUDI MODALE AGGIUNTA UTENTE

  /*SALVA MODIFICHE */
  const handleSaveModifyClick = async () => {
    try {
      const response = await axios.put(
        `${API_URL}/admin/users/${editUserId}`,
        userData
      );

      // Controlla se la risposta è positiva
      if (response.status === 200) {
        setUsers((prevUsers) =>
          prevUsers.map((user) =>
            user.id_utente === editUserId ? { ...user, ...userData } : user
          )
        );
        handleCloseModifyModal(); // Chiudi il modale dopo il salvataggio
      }
    } catch (error) {
      // Log dell'errore
      console.error("Error updating user:", error);

      // Mostra un messaggio di errore più specifico
      const errorMessage =
        error.response?.data?.message ||
        "Si è verificato un errore nell'aggiornamento dei dati dell'utente.";
      setEditError(errorMessage);
    }
  };

  /* Add user */
  const handleAddUserClick = async () => {
    try {
      const cleanedUserData = Object.fromEntries(
        Object.entries(userData).map(([key, value]) => [
          key,
          value.trim() === "" ? null : value,
        ])
      );
      console.log("User data AGGIUNTA:", userData);
      await axios.post(`${API_URL}/admin/users`, cleanedUserData);
      //setUsers([...users, userData]); // Aggiungi il nuovo utente alla lista

      handleCloseAddUserModal();
    } catch (error) {
      console.error("Errore nell'aggiunta dell'utente:", error);
      setError("Si è verificato un errore nell'aggiunta dell'utente.");
    }
  };

  const handleCancelClick = () => handleCloseModifyModal();

  /*AGGIUNGI UTENTE */
  const addUser = async () => {
    setEditUserId(null);
    await setUserData({
      nome: "",
      cognome: "",
      email: "",
      num_tel: "",
      ruolo: "user",
      indirizzo: "",
      comune: "",
      provincia: "",
      cap: "",
    });
    handleOpenAddUserModal();
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value); // Aggiorna lo stato con il valore della barra di ricerca
  };

  /*FILTRO*/

  const filteredData = users.filter(
    (item) =>
      item.nome.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.cognome.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (item.num_tel !== null &&
        item.num_tel !== undefined &&
        item.num_tel.includes(searchTerm)) // Filtro per il campo "num_tel"
  );

  return (
    <div>
      <Header />
      <div className="flex min-h-screen bg-gray-100">
        {/* Sidebar */}
        <Sidebar />
        <div className="flex-1 p-6">
          <h1 className="text-4xl font-bold mb-8 text-gray-800">
            Gestione Utenti
          </h1>
          <div className="flex justify-between items-center mb-6">
            <input
              type="text"
              value={searchTerm}
              onChange={handleSearchChange}
              className="p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Cerca utente"
            />
            <div className="flex space-x-5">
              <button
                className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 transition duration-200"
                onClick={addUser}
              >
                Aggiungi Utente
              </button>
              <button className="bg-red-500 text-white px-4 py-2 rounded mx-4 hover:bg-red-600 focus:outline-none">
                Rimuovi Utente
              </button>
            </div>
          </div>

          <table className="min-w-full bg-white">
            <thead>
              <tr className="bg-gray-200 text-gray-600 uppercase text-sm leading-normal">
                <th className="py-2 px-4 border-b">ID</th>
                <th className="py-2 px-4 border-b">Nome</th>
                <th className="py-2 px-4 border-b">Email</th>
                <th className="py-2 px-4 border-b">Telefono</th>
                <th className="py-2 px-4 border-b">Ruolo</th>
                <th className="py-2 px-4 border-b">Azioni</th>
              </tr>
            </thead>
            {filteredData.length > 0 ? (
              <tbody className="text-gray-700 text-md">
                {filteredData.map(
                  (
                    user // Aggiunta delle parentesi graffe per la mappatura
                  ) => (
                    <tr
                      key={user.id_utente}
                      className="hover:bg-gray-100 transition duration-200"
                    >
                      <td className="py-2 px-4 border-b">{user.id_utente}</td>
                      <td className="py-2 px-4 border-b border-x text-left">
                        {`${user.cognome || ""} ${user.nome || ""}`.trim()}
                      </td>
                      <td className="py-2 px-4 border-b border-x">
                        {user.email}
                      </td>
                      <td className="py-2 px-4 border-b border-x">
                        {user.num_tel}
                      </td>
                      <td className="py-2 px-4 border-b border-x">
                        {user.ruolo}
                      </td>
                      <td className="py-2 px-4 border-b ">
                        <button
                          className="bg-blue-500 text-white py-1 px-2 rounded"
                          onClick={() => handleEditClick(user)} // Passa l'utente per modificarlo
                        >
                          Modifica
                        </button>
                      </td>
                    </tr>
                  )
                )}
              </tbody>
            ) : (
              <tbody>
                <tr>
                  <td colSpan="6" className="py-2 px-4 border-b text-center">
                    Nessun risultato trovato.
                  </td>
                </tr>
              </tbody>
            )}
          </table>

          <ModifyUser
            userData={userData}
            onChange={(updatedData) => setUserData(updatedData)}
            isOpen={isModifyModalOpen}
            onClose={handleCloseModifyModal}
            onConfirm={handleSaveModifyClick}
            errorMessage={editError}
            setErrorMessage={setEditError}
            title="Modifica Utente"
            message="Modifica i dati dell'utente."
            confirmLabel="Salva"
            cancelLabel="Annulla"
            iconColor="text-blue-600"
            iconBgColor="bg-blue-100"
            confirmBgColor="bg-blue-500"
            confirmHoverBgColor="hover:bg-blue-600"
            confirmTextColor="text-white"
            cancelBgColor="bg-white"
            cancelHoverBgColor="hover:bg-gray-100"
            cancelTextColor="text-gray-900"
          />

          <ModifyUser
            userData={userData}
            onChange={(updatedData) => setUserData(updatedData)}
            isOpen={isAddUserModalOpen}
            onClose={handleCloseAddUserModal}
            onConfirm={handleAddUserClick}
            title="Aggiungi Utente"
            message="Inserisci i dati dell'utente."
            confirmLabel="Aggiungi"
            cancelLabel="Annulla"
            iconColor="text-blue-600"
            iconBgColor="bg-blue-100"
            confirmBgColor="bg-blue-500"
            confirmHoverBgColor="hover:bg-blue-600"
            confirmTextColor="text-white"
            cancelBgColor="bg-white"
            cancelHoverBgColor="hover:bg-gray-100"
            cancelTextColor="text-gray-900"
          />
        </div>
      </div>
    </div>
  );
};

export default UserManagement;
